if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      connectedCallback() {
        // Initialize auto-play for the initially active slide when element is connected to DOM
        this.initializeAutoPlay();
      }

      initializeAutoPlay() {
        // Use requestAnimationFrame to ensure DOM is fully rendered
        requestAnimationFrame(() => {
          setTimeout(() => {
            // Ensure viewer element exists
            if (!this.elements.viewer) {
              console.log('Viewer element not found');
              return;
            }
            
            // Try to find the active slide
            let activeSlide = this.elements.viewer.querySelector('.is-active');
            
            // If no active slide found, get the first slide
            if (!activeSlide) {
              activeSlide = this.elements.viewer.querySelector('[data-media-id]');
            }
            
            if (activeSlide) {
              console.log('Initializing auto-play for:', activeSlide);
              this.autoPlayVideos(activeSlide);
            } else {
              console.log('No active slide found for auto-play');
            }
          }, 300);
        });
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        // Stop all media first
        window.pauseAllMedia();
        
        // Load deferred media content if present
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
        
        // Auto-play videos in the active slide
        this.autoPlayVideos(activeItem);
      }

      autoPlayVideos(activeItem) {
        console.log('Auto-playing videos for:', activeItem);
        
        // Handle regular HTML5 videos
        const videos = activeItem.querySelectorAll('video');
        console.log('Found', videos.length, 'video elements');
        
        videos.forEach((video) => {
           // video.removeAttribute('controls');
          console.log('Processing video:', video, 'readyState:', video.readyState);
          if (video.readyState >= 4) {
            // Video is ready to play
            console.log('Video is ready, playing...');
            video.play().catch(e => {
              console.log('Video autoplay was prevented:', e);
            });
          } else {
            // Wait for video to be ready
            console.log('Video not ready, waiting for loadeddata...');
            video.addEventListener('loadeddata', () => {
              console.log('Video loaded, playing...');
              video.play().catch(e => {
                console.log('Video autoplay was prevented:', e);
              });
            }, { once: true });
          }
        });

        // Handle deferred media videos (like YouTube, Vimeo)
        const deferredMedia = activeItem.querySelector('.deferred-media[loaded]');
        const deferredMediaNotLoaded = activeItem.querySelector('.deferred-media:not([loaded])');
        
        console.log('Deferred media (loaded):', deferredMedia);
        console.log('Deferred media (not loaded):', deferredMediaNotLoaded);
        
        if (deferredMedia) {
          // Check for HTML5 video in deferred content
          const deferredVideo = deferredMedia.querySelector('video');
          if (deferredVideo) {
            console.log('Found deferred video, playing...');
            setTimeout(() => {
              deferredVideo.play().catch(e => {
                console.log('Deferred video autoplay was prevented:', e);
              });
            }, 100);
          }
          
          // Handle YouTube videos
          const youtubeFrame = deferredMedia.querySelector('.js-youtube');
          if (youtubeFrame) {
            console.log('Found YouTube frame, playing...');
            setTimeout(() => {
              youtubeFrame.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            }, 100);
          }
          
          // Handle Vimeo videos
          const vimeoFrame = deferredMedia.querySelector('.js-vimeo');
          if (vimeoFrame) {
            console.log('Found Vimeo frame, playing...');
            setTimeout(() => {
              vimeoFrame.contentWindow.postMessage('{"method":"play"}', '*');
            }, 100);
          }
        }
        
        // If deferred media is not loaded, load it first
        if (deferredMediaNotLoaded) {
          console.log('Loading deferred media and then playing...');
          deferredMediaNotLoaded.loadContent(false);
          setTimeout(() => {
            this.autoPlayVideos(activeItem);
          }, 200);
        }
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
